import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const fetchFeatured = (page = 1) =>
  axios.get(`${API}asplapi/featured/?page=${page}`);

export const searchLive = (q) =>
  axios.get(`${API}asplapi/search/?q=${encodeURIComponent(q)}`);

export const searchLocalIndex = (q, page = 1) =>
  axios.get(`${API}asplapi/index/search/?q=${encodeURIComponent(q)}&page=${page}`);

export const autocompleteSearch = (q) =>
  axios.get(`${API}asplapi/index/search/?q=${encodeURIComponent(q)}`);

export const getProductById = (id) =>
  axios.get(`${API}asplapi/products/?ids=${id}`);

export const fetchAdminAsplProducts = (q = "", page = 1, pageSize = 20) =>
  axios.get(
    `${API}asplapi/admin/products/?q=${encodeURIComponent(q)}&page=${page}&page_size=${pageSize}`
  );

export const updateAdminAsplProduct = (asplId, payload) =>
  axios.patch(`${API}asplapi/admin/products/${asplId}/`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
